import styled from 'styled-components/macro';
import { colorCoreGray500 } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
export const ContainerStyled = styled.div `
  display: flex;
  flex: 1;
  padding-bottom: 8px;
  border-bottom: 1px solid ${colorCoreGray500};
`;
export const ColWrapperStyled = styled(FlexWrapper) `
  ${({ width }) => width && `width: ${width}`};

  padding-left: 8px;
  padding-right: 8px;

  &:first-child {
    padding-left: 0;
  }

  &:last-child {
    padding-right: 0;
  }
`;
